import React from 'react';
import './LegalPages.css';

const AboutPage = ({ setCurrentPage }) => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>À propos de SoundNest</h1>
        
        <section>
          <h2>Notre mission</h2>
          <p>
            SoundNest est une plateforme web moderne qui vous permet de découvrir, écouter et télécharger 
            des sons libres de droits de haute qualité. Notre objectif est de rendre accessible à tous 
            une vaste bibliothèque sonore pour vos projets créatifs.
          </p>
        </section>

        <section>
          <h2>Comment ça fonctionne</h2>
          <p>
            Notre site vous permet de :
          </p>
          <ul>
            <li>Parcourir des milliers de sons organisés par catégories</li>
            <li>Écouter les sons en streaming directement dans votre navigateur</li>
            <li>Sauvegarder vos sons préférés dans vos favoris</li>
            <li>Rechercher des sons spécifiques grâce à notre moteur de recherche intelligent</li>
            <li>Télécharger les sons qui vous intéressent</li>
          </ul>
        </section>

        <section>
          <h2>Source des contenus</h2>
          <p>
            Tous les sons disponibles sur SoundNest proviennent de <strong>LaSonotheque.org</strong>, 
            une plateforme reconnue qui propose des sons libres de droits sous licence Creative Commons. 
            Nous ne stockons aucun fichier audio sur nos serveurs - tous les sons sont lus en streaming 
            et téléchargés directement depuis leurs serveurs.
          </p>
        </section>

        <section>
          <h2>Technologie</h2>
          <p>
            SoundNest est développé avec les technologies web modernes :
          </p>
          <ul>
            <li><strong>React</strong> - Framework JavaScript pour l'interface utilisateur</li>
            <li><strong>CSS moderne</strong> - Design responsive et accessible</li>
            <li><strong>API REST</strong> - Communication avec les services externes</li>
            <li><strong>Progressive Web App</strong> - Expérience optimisée sur tous les appareils</li>
          </ul>
        </section>

        <section>
          <h2>Respect de la vie privée</h2>
          <p>
            Nous respectons votre vie privée. SoundNest ne collecte aucune donnée personnelle. 
            Vos favoris sont stockés localement dans votre navigateur et ne sont jamais transmis 
            à nos serveurs. Pour plus d'informations, consultez notre 
            <button className="inline-link" onClick={() => setCurrentPage('politique-confidentialite')}>
              politique de confidentialité
            </button>.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            SoundNest est un projet personnel développé avec passion. Pour toute question ou suggestion, n'hésitez pas à nous contacter à l'adresse e-mail suivante : <a href="mailto:help.wertazzou@gmail.com">help.wertazzou@gmail.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
